import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
function initials(author: string): string {
  return author.charAt(0).toUpperCase();
}
export function TestimonialsSection() {
  return <section className="defer-paint w-full bg-zinc-950 py-12 sm:py-14" aria-labelledby="testimonials-heading" data-id="element-175" data-mp="1mz949hkd4eh0">
      <div className="mx-auto max-w-6xl px-6" data-id="element-176" data-mp="1qzt08ht79c1k">
        <div className="mx-auto max-w-2xl text-center" data-id="element-177" data-mp="1d24hpgmlugzo">
          <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.22em] text-yellow-500" data-id="element-178" data-mp="1d0jkfj8wojy4">In pista</p>
          <h2 id="testimonials-heading" className="mt-4 font-serif text-[2rem] font-bold leading-[1.1] text-stone-100 sm:text-4xl" data-id="element-179" data-mp="1hyl4a6e5onan">
            Cosa dicono gli allenatori
          </h2>
        </div>

        <ul className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-180" data-mp="184kzk5msdk2g">
          {testimonials.map(testimonial => <li key={testimonial.author} className="flex h-full flex-col rounded-3xl border border-zinc-800 bg-zinc-900 p-6" data-id="element-181" data-mp="2yd37uz1zttfu">
              <div className="flex gap-1" aria-label="5 stelle su 5" data-id="element-182" data-mp="2v1b10yehtyp0">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-yellow-500 text-yellow-500" aria-hidden="true" data-id="element-183" data-mp="2q1pxeaodp25y" data-mpi={index} />)}
              </div>

              <blockquote className="mt-4 font-sans text-[0.9rem] leading-relaxed text-stone-200" data-id="element-184" data-mp="34t8cm69eyso9">
                “{testimonial.quote}”
              </blockquote>

              <footer className="mt-auto flex items-center gap-3 pt-6" data-id="element-185" data-mp="2c38gavszanx0">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-yellow-500/30 bg-yellow-500/10 font-serif text-base font-bold text-yellow-500" aria-hidden="true" data-id="element-186" data-mp="274f4d7tcb4yy">
                  {initials(testimonial.author)}
                </span>
                <span className="font-sans text-sm" data-id="element-187" data-mp="1a5n39sfdx7e">
                  <span className="block font-semibold text-stone-100" data-id="element-188" data-mp="18u9yjd3bd3m">
                    {testimonial.author}
                  </span>
                  <span className="block text-xs text-stone-400" data-id="element-189" data-mp="3f0uhkhjzwvy">
                    {testimonial.role} · {testimonial.location}
                  </span>
                </span>
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}